import { createStore, applyMiddleware, compose } from 'redux';
import createSagaMiddleware from 'redux-saga';
import rootSaga from '../rootes'; // À adapter si besoin
import createReducer from '../reducers';

export default function configureStore(initialState = {}) {
    let composeEnhancers = compose;
    const reduxSagaMonitorOptions = {};

    // Redux DevTools intégration
    if (process.env.NODE_ENV !== 'production' && typeof window === 'object') {
        if (window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__) {
            composeEnhancers = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__({
                trace: true,
                traceLimit: 25,
            });
        }
    }

    // Créer le middleware saga
    const sagaMiddleware = createSagaMiddleware(reduxSagaMonitorOptions);

    // Middlewares
    const middlewares = [sagaMiddleware];

    const enhancers = [applyMiddleware(...middlewares)];

    // Créer le store
    const store = createStore(
        createReducer(),
        initialState,
        composeEnhancers(...enhancers),
    );

    // Lancer les sagas
    sagaMiddleware.run(rootSaga);

    // Extensions pour injection dynamique
    store.runSaga = sagaMiddleware.run;
    store.injectedReducers = {}; // Registry des reducers injectés
    store.injectedSagas = {}; // Registry des sagas injectées

    // Hot Module Reloading
    if (module.hot) {
        module.hot.accept('../reducers', () => {
            store.replaceReducer(createReducer(store.injectedReducers));
        });
    }

    return store;
}